export function getDomContainer(name: string): HTMLElement {
  const containerId = name

  let container: HTMLElement | null = document.getElementById(containerId)

  if (!container) {
    container = document.createElement('div')
    container.id = containerId;

    document.body.appendChild(container)
  }

  return container
}
